<app-page-header [heading]="'Item'" [icon]="'fa-medkit'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
    <div class="row">
        <div class="form-group  col-lg-3">
            <label>Product Code</label>
            <span style="padding-left:100px"><input [(ngModel)]="checked" type="checkbox">  </span>
            <input [(ngModel)]="medicine_data.product_code" [disabled]="!checked" class="form-control"
                   maxlength="25" name="product_code" type="text">
        </div>
        <div class="form-group col-lg-3">
            <label>Code</label>
            <input [(ngModel)]="medicine_data.hsn_code" class="form-control " maxlength="50" name="hsn_code"
                   type="text">
        </div>
        <div class="form-group col-lg-3">
            <label>Item</label><span class="text-danger">&nbsp;*</span>
            <input [(ngModel)]="medicine_data.trade_name" class="form-control" maxlength="100"
                 name="trade_name" type="text">
        </div>
        <div class="form-group col-lg-3">
            <label>Brand</label>
            <select [(ngModel)]="medicine_data.category"
                    class="form-control  custom-select custom-select-sm ng-pristine ng-valid ng-touched"
                    name="category">
                <option value="0">Select Brand</option>
                <option *ngFor="let data of category" class="ng-tns-c13-1 ng-star-inserted"
                        value="{{data.CATEGORY_ID}}">{{ data.DESCRIPTION }}
                </option>
            </select>
        </div>
        <div class="form-group col-lg-3">
            <label>Unit</label><span class="text-danger">&nbsp;*</span>
            <select [(ngModel)]="medicine_data.unit"
                    class="form-control  custom-select custom-select-sm ng-pristine ng-valid ng-touched"
                    name="unit">
                <option value="">Select Unit</option>
                <option *ngFor="let data of unit" class="ng-tns-c13-1 ng-star-inserted"
                        value="{{data.UNIT_ID}}">{{ data.UNIT_DESC }}
                </option>
            </select>
        </div>
        <div class="form-group col-lg-3">
            <label>Manufacturer</label>
            <input [(ngModel)]="medicine_data.manufacturer" class="form-control " maxlength="100" name="manufacturer" type="text">
        </div>
        <div class="form-group col-lg-3">
            <label>VAT</label>
            <div class="input-group mb-2">
                <input [(ngModel)]="medicine_data.vat" [appOnlyNumber]="true" class="form-control" maxlength="5"
                       name="vat" style="height:29px" type="text">
                <div class="input-group-append">
                    <label class="input-group-text day">
                        ( % )
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group col-lg-3">
            <label>Registered Owner</label>
            <input [(ngModel)]="medicine_data.registered_owner" class="form-control " maxlength="100"
                   name="registered_owner"
                   type="text">
        </div>
        <div class="form-group col-lg-3">
            <label>Safety Stock</label>
            <input [(ngModel)]="medicine_data.safty_stock" class="form-control " maxlength="10"
                   name="safty_stock"
                   type="text">
        </div>
        <div class="form-group col-lg-3">
            <label>Reorder Level Quantity</label>
            <input [(ngModel)]="medicine_data.reorder" class="form-control " maxlength="10" name="reorder"
                   type="text">
        </div>

        <div class="form-group col-lg-3">
            <label>Location</label>
            <textarea [(ngModel)]="medicine_data.location" class="form-control " maxlength="100"
                      name="location"
                      type="text"></textarea>
        </div>
    </div>
    <div class="clearfix"></div>
    <div class="row container">
        <div class="col-lg-7 pull-right">
            <button (click)="saveMedicine();" *ngIf="user_rights.ADD == '1'"
                    class="btn btn-info btn-sm ng-star-inserted"
                    type="button">&nbsp;Save&nbsp;
            </button>&nbsp;&nbsp;&nbsp;
            <button (click)="clearMedicine();" *ngIf="user_rights.ADD == '1'" class="btn btn-danger btn-sm"
                    type="button">
                &nbsp;Clear&nbsp;
            </button>
        </div>
    </div>
</div>

<div class="page-break">
    <div class=" row ">
        <div class="col-lg-8">
            <h4 class="list-header">Item List</h4>
        </div>
        <div class="col-lg-4">
            <div class="input-group ">
                <input (keydown)="keyDownFunction($event)" [(ngModel)]="medicine_data.search_medicine"
                       class="form-control"
                       id="typeahead-http"
                       name="search_text" placeholder="Item / Product Code / Code..." style="height:31px"
                       type="text">
                <div class="input-group-append">
                    <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
                        <i *ngIf="medicine_data.search_medicine != ''" class="fa fa-close"></i>
                        <i *ngIf="medicine_data.search_medicine == ''" class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="this.status == 'Failed'"><span [hidden]="this.status == 'Success'"
                                                   style="color:red;font-size:13px;"> Sorry, suggestions could not be loaded.</span>
        </div>
    </div>
    <div class="clearfix"></div>

    <div class="">
        <table class="table tbl table-hover table-striped table-bordered">
            <thead class="text-center">
            <tr>
                <th>Sl#</th>
                <th>Product Code</th>
                <th>Code</th>
                <th>Item</th>
                <th>Brand</th>
                <th>VAT</th>
                <th width="10%">Action</th>
            </tr>
            <tr *ngIf="(medi_data | json) == '[]'">
                <td class="text-center" colspan="10">No data to list</td>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let data of medi_data;let i=index" style="font-size: 12px">
                <td>{{ start + i + 1 }}</td>
                <td>{{ data.PRODUCT_CODE }}</td>
                <td>{{ data.HSN_CODE }}</td>
                <td>{{ data.TRADE_NAME }}</td>
                <td>{{ data.DESCRIPTION }}</td>
                <td>{{ data.VAT }}</td>
                <td class="text-center">
                    <button (click)="editMedicine(data);" *ngIf="user_rights.EDIT == '1'" alt="Edit"
                            class="btn btn-sm btn-info"
                            style="font-size: 10px" title="Edit"><i class="fa fa-edit"></i></button>
                    &nbsp;&nbsp;
                    <button (click)="deleteMedicine(data.MEDICINE_ID);" *ngIf="user_rights.DELETE == '1'" alt="Delete"
                            class="btn btn-sm btn-danger"
                            style="font-size: 10px" title="Delete"><i class="fa fa-trash"></i></button>
                </td>
            </tr>
            </tbody>
        </table>
        <app-pagination (pageChange)="getMedicineList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
    </div>
</div>


